export type DeutscheBahnSummaryPassenger = {
  firstName: string;
  lastName: string;
  passengerType: string | undefined;
};

/**
 * Merges an estimation passenger row with the matching form row for display.
 * Prefers the API values and falls back to the form when the API omits a field (e.g. `passenger_type`).
 * No per-passenger price — Deutsche Bahn returns a single group price.
 */
export function resolveDeutscheBahnSummaryPassenger(
  pricedPassenger: any,
  formPassenger: any
): DeutscheBahnSummaryPassenger {
  return {
    firstName: pricedPassenger?.first_name ?? formPassenger?.first_name ?? "",
    lastName: pricedPassenger?.last_name ?? formPassenger?.last_name ?? "",
    passengerType: pricedPassenger?.passenger_type ?? formPassenger?.passenger_type
  };
}

/**
 * Summary rows: the estimation passengers when present, otherwise the form passengers.
 */
export function resolveDeutscheBahnSummaryPassengers(
  pricedPassengers: any,
  formPassengers: any
): DeutscheBahnSummaryPassenger[] {
  const formList = Array.isArray(formPassengers) ? formPassengers : [];
  const pricedList = Array.isArray(pricedPassengers) && pricedPassengers.length > 0 ? pricedPassengers : formList;

  return pricedList.map((pricedPassenger: any, index: number) =>
    resolveDeutscheBahnSummaryPassenger(pricedPassenger, formList[index])
  );
}
